import styled from 'styled-components';
import rtl from 'styled-components-rtl';
import { toRem, theme } from '@marriott/mi-ui-library-shop';
import { DateBoxProps } from './datesHeader.types';

export const StyledDatesHeaderDiv = styled.div`
  ${rtl`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  padding: 0 ${toRem(24)} ${toRem(19)};
  @media ${theme.mediaQuery.allMobiles} {
    padding:;
    padding-top:${toRem(5)};
  }
  @media ${theme.mediaQuery.tablet} {
    padding: 0 ${toRem(24)} ${toRem(20)};
  }
  @media ${theme.mediaQuery.desktop} {
    padding: 0 ${toRem(32)} ${toRem(20)};
  }
  @media ${theme.mediaQuery.largeDesktop} {
    padding: 0 ${toRem(40)} ${toRem(20)};
  }
`}
`;

export const StyledDateBoxDiv = styled.div`
  ${rtl`
    width: ${toRem(175)};
    position: relative;
    @media ${theme.mediaQuery.desktop} {
        width: ${toRem(218)};
    }

    &:hover{
        ${(props: DateBoxProps): string => (!props.focused ? `opacity: 0.6;` : '')}
    }

    &:first-child {
        margin-right: ${toRem(40)};
        @media ${theme.mediaQuery.desktop} {
            margin-right: ${toRem(32)};
        }
         @media ${theme.mediaQuery.largeDesktop} {
            margin-right: ${toRem(40)};
        }
    }

    &:nth-child(2) {
        padding-left: ${toRem(24)};
        border-left: ${toRem(1)} dashed ${theme.color['dark-gray-6']};
        @media ${theme.mediaQuery.desktop} {
            padding-left: ${toRem(32)};
        }
        @media ${theme.mediaQuery.largeDesktop} {
            padding-left: ${toRem(40)};
        }
    }
    .dates-header-label {
         @media ${theme.mediaQuery.desktop} {
            letter-spacing: ${toRem(1.3)};
        }
    }

    button {
        outline: none;
        cursor: pointer;
        background: transparent;
        padding: 0;
        border: none;

        &:first-child {
            display: flex;
            flex-direction: column;
            white-space: nowrap;
            padding-bottom: ${toRem(14)};
            border-bottom: ${(props: DateBoxProps): string =>
              props.focused
                ? `${toRem(3)} solid ${theme.color.black}`
                : `${toRem(1)} solid ${theme.color['light-gray-6']}`};
            text-align: start;
            text-overflow: ellipsis;
            overflow: hidden;
            width: 100%;;

            span {
                &.gray-shade {
                    color: ${theme.color['dark-gray-4']};
                }

                &:first-child {
                    padding-bottom: ${toRem(6)};
                    text-transform: uppercase;
                    ${(props: DateBoxProps): string => (props.focused ? `color: ${theme.color.black};` : '')}
                    @media ${theme.mediaQuery.desktop} {
                        padding-bottom: ${toRem(4)};
                    }
                }
            }
        }
        &:nth-child(2){
            font-size: ${toRem(24)};
            line-height: ${toRem(20)};
            position: absolute;
            bottom: ${toRem(19)};
            right: 0;
            padding: 0;
            ::before {
                color: ${theme.color['base-10']};
                height: ${toRem(20)};
                width: ${toRem(20)};
            }
        }
    }
`}
`;
